import { PrintApiService } from "../../shared/print-api/PrintApiService";
import { PeripheralServiceConfig, PeripheralType } from "../../shared/types";
import {  PrintApiPrinter, PrintApiServiceConfig, PrintApiPrinterType } from "../../shared/print-api/types";
import { PrintApiReceiptPrinter } from "./PrintApiReceiptPrinter";

export class PrintApiReceiptPrinterService extends PrintApiService<PrintApiReceiptPrinter> {
  constructor(config: Partial<PeripheralServiceConfig> & PrintApiServiceConfig) {
    super(PeripheralType.receiptPrinter, "PrintApiReceiptPrinterService", config);
  }

  protected createPrinter(device: PrintApiPrinter): PrintApiReceiptPrinter {
    return new PrintApiReceiptPrinter(device);
  }
  
  protected shouldIncludePrinter(device: PrintApiPrinter): boolean {
    return device.type === PrintApiPrinterType.receipt;
  }
}
